import React from "react";
import PropTypes from "prop-types";
import { Container, Transition, Table } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import Fila from "./tabla/Fila";
import sortBy from "lodash/sortBy";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";

const propTypes = {
  datos: PropTypes.array.isRequired
};

class Tabla extends React.Component {
  state = {
    column: this.props.columnaSeleccionada.column,
    data: sortBy(this.props.datos, [this.props.columnaSeleccionada.column]),
    direction: this.props.columnaSeleccionada.direction,
    redirect: false,
    redirectTo: null
  };

  componentWillReceiveProps({ datos, columnaSeleccionada }, nextContext) {
    this.setState(({ column }) => ({
      data:
        columnaSeleccionada.direction === "ascending"
          ? sortBy(datos, [columnaSeleccionada.column])
          : sortBy(datos, [columnaSeleccionada.column]).reverse(),
      column: columnaSeleccionada.column,
      direction: columnaSeleccionada.direction
    }));
  }

  componentWillUnmount() {
    this.setState({ data: null });
  }

  handleSort = clickedColumn => () => {
    this.setState(
      ({ column, data, direction }) => ({
        column: column !== clickedColumn ? clickedColumn : column,
        data:
          column !== clickedColumn
            ? sortBy(data, [clickedColumn])
            : data.reverse(),
        direction:
          column !== clickedColumn
            ? "ascending"
            : direction === "ascending"
              ? "descending"
              : "ascending"
      }),
      () =>
        this.props.onColumnSelect({
          column: this.state.column,
          direction: this.state.direction
        })
    );
  };

  handleRowClick = idInscripcion =>
    this.setState({
      redirect: true,
      redirectTo: (
        <Redirect
          to={`/preinscripciones/${this.props.idColegio}/${idInscripcion}`}
        />
      )
    });

  render() {
    const { column, data, direction, redirect, redirectTo } = this.state;
    return redirect ? (
      redirectTo
    ) : (
      <Transition.Group animation="scale" duration={250}>
        {!isEmpty(data) && (
          <Container fluid>
            <Table sortable structured>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell
                    sorted={column === "nombre" ? direction : null}
                    onClick={this.handleSort("nombre")}
                    content="Nombre"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "apellido1" ? direction : null}
                    onClick={this.handleSort("apellido1")}
                    content="Apellidos"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "edad" ? direction : null}
                    onClick={this.handleSort("edad")}
                    content="Edad"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "telefonos" ? direction : null}
                    onClick={this.handleSort("telefonos")}
                    content="Telefonos"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "servicios" ? direction : null}
                    onClick={this.handleSort("servicios")}
                    content="Servicios"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "formaDePago" ? direction : null}
                    onClick={this.handleSort("formaDePago")}
                    content="Forma de Pago"
                    textAlign="center"
                  />
                  <Table.HeaderCell content="Adjuntos" textAlign="center" />
                  <Table.HeaderCell content="Acciones" textAlign="center" />
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {map(data, d => (
                  <Fila
                    key={d.idInscripcion}
                    handleClick={this.handleRowClick}
                    handleConfirm={this.props.handleRowConfirm}
                    handleMatinal={this.props.handleMatinal}
                    handleVespertina={this.props.handleVespertina}
                    handleBorrarLinea={this.props.handleBorrarLinea}
                    {...d}
                    confirmada={
                      this.props.confirmacionCompleta &&
                      this.props.inscripcionConfirmada === d.idInscripcion
                    }
                  />
                ))}
              </Table.Body>
            </Table>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

Tabla.propTypes = propTypes;

export default Tabla;



// WEBPACK FOOTER //
// ./src/pages/preinscripciones/listaPreinscripciones/Tabla.jsx